import { Injectable } from '@angular/core';
import { DragDropContainerService } from '../../drag-drop/services/container.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { User } from '../../../api/backend/types/users';
import { maintenanceOptions } from '../../../core/models/scheduler/maintenance';
import { SchedulerBaseItem } from '../models/item';
import { MoldRevision } from '../../../api/elite/types/mold-revision';

@Injectable({
  providedIn: 'root',
})
export class SchedulerContainerService<
  Type extends SchedulerBaseItem
> extends DragDropContainerService<Type> {
  protected _removeMoldRevisions = new Subject<MoldRevision>();
  removeMoldRevisions$ = this._removeMoldRevisions.asObservable();

  // When you want to delete an item from all lists
  protected _itemDeleted = new Subject<Type>();
  itemDeleted$ = this._itemDeleted.asObservable();

  protected _addAccumulationBatch = new Subject<Type>();
  addAccumulationBatch$ = this._addAccumulationBatch.asObservable();

  // When you want to change a single value of an item across all lists
  protected _itemUpdated = new Subject<{
    itemId: number;
    value: Partial<Type>;
  }>();
  itemUpdated$ = this._itemUpdated.asObservable();
  set updateItem(value: { itemId: number; value: Partial<Type> }) {
    this._itemUpdated.next(value);
  }

  // When you want to sent it directly to the waiting list
  protected _toWaitingList = new Subject<Type>();
  toWaitingList$ = this._toWaitingList.asObservable();

  // When an item is moved into a machine — only the table-list reacts (to drop it
  // from its visible list). Machines must NOT subscribe to this, since the
  // destination machine has just added the item.
  protected _itemMovedToMachine = new Subject<Type>();
  itemMovedToMachine$ = this._itemMovedToMachine.asObservable();
  notifyItemMovedToMachine(item: Type): void {
    this._itemMovedToMachine.next(item);
  }

  // All the operator options stored here
  private _operatorOptions = new BehaviorSubject<User[]>([]);
  operatorOptions$ = this._operatorOptions.asObservable();
  set operatorsOptions(value: User[]) {
    this._operatorOptions.next(value);
  }

  // All the maintenance options stored here
  private _maintenanceOptions: { id: number; title: string }[] =
    maintenanceOptions;
  get maintenanceOptions(): { id: number; title: string }[] {
    return [...this._maintenanceOptions];
  }

  // Global filter that is going to be applied to all lists
  private _globalFilter = new BehaviorSubject<string>('');
  globalFilter$ = this._globalFilter.asObservable();
  set globalFilter(value: string) {
    this._globalFilter.next(value);
  }

  // Si el filtro global deberia ser aplicado a las maquinas
  private _globalFilterMachines = new BehaviorSubject<boolean>(false);
  globalFilterMachines$ = this._globalFilterMachines.asObservable();
  set globalFilterMachines(value: boolean) {
    this._globalFilterMachines.next(value);
  }

  deleteFromAllLists(item: Type): void {
    this._itemDeleted.next(item);
  }

  moveToWaitingList(item: Type): void {
    this._toWaitingList.next(item);
  }

  removeMoldRevision(item: MoldRevision): void {
    this._removeMoldRevisions.next(item);
  }
}
